<template>
  <Form
    :id="id.toString()"
    :action="action"
    :kolok-val="kolok"
    :kib-val="kib"
    :kobar-val="kobar"
    :nabar-val="nabar"
    :kode-register-barang-val="kodeRegisterBarang"
    :keberadaan-val="keberadaan"
    :wujud-val="wujud"
    :alasan-tidak-ada-val="alasanTidakAda"
    :alasan-tidak-ada-p-val="alasanTidakAdaP"
    :aset-induk-val="asetInduk"
    :pd-ukpd-val="pdUkpd"
    :kolok-pd-ukpd-val="kolokPdUkpd"
    :kobar-induk-val="kobarInduk"
    :nabar-induk-val="nabarInduk"
    :register-barang-val="registerBarang"
    :alasan-tidak-ada-note-val="alasanTidakAdaNote"
    :no-sk-penghapusan-val="noSkPenghapusan"
    :bagian-dari-aset-induk-val="bagianDariAsetInduk"
    :kondisi-barang-val="kondisiBarang"
    :provinsi-val="provinsi"
    :kab-kota-val="kabKota"
    :kecamatan-val="kecamatan"
    :kelurahan-val="kelurahan"
    :jalan-val="jalan"
    :no-alamat-val="noAlamat"
    :rt-val="rt"
    :rw-val="rw"
    :kode-pos-val="kodePos"
    :latitude-val="latitude"
    :longitude-val="longitude"
    :tanda2batas-tanah-utara-val="tanda2BatasTanahUtara"
    :tanda2batas-tanah-timur-val="tanda2BatasTanahTimur"
    :tanda2batas-tanah-selatan-val="tanda2BatasTanahSelatan"
    :tanda2batas-tanah-barat-val="tanda2BatasTanahBarat"
    :keterangan-beton-val="keteranganBeton"
    :keterangan-beton-sebutkan-val="keteranganBetonSebutkan"
    :plang-val="plang"
    :plang-p-val="plangP"
    :pagar-val="pagar"
    :pagar-p-val="pagarP"
    :catatan-val="catatan"
    :status-val="status"
    :gambar-val="gambar"
    :peruntukkan-val="peruntukkan"
    :is-bertingkat-val="isBertingkat"
    :bertingkat-seharusnya-val="bertingkatSeharusnya"
    :kesesuaian-kode-barang-val="kesesuaianKodeBarang"
    :kib-seharusnya-val="kibSeharusnya"
    :kode-barang-seharusnya-val="kodeBarangSeharusnya"
    :is-show-ubah-val="isShowUbah"
  />
</template>

<script>
import { ref } from '@vue/composition-api'
import Form from './Form2.vue'
import validasiKeberadaan from '@/composables/validasiKeberadaan'
import master from '@/composables/master'

export default {
  setup(props, context) {
    const g = context.root

    const kolok = ref('')
    const kib = ref('')
    const kobar = ref('')
    const nabar = ref('')
    const kodeRegisterBarang = ref('')
    const keberadaan = ref('')
    const wujud = ref('')

    const alasanTidakAda = ref('')
    const alasanTidakAdaP = ref('')
    const asetInduk = ref('')
    const pdUkpd = ref('')
    const kolokPdUkpd = ref('')
    const nabarInduk = ref('')
    const kobarInduk = ref('')
    const registerBarang = ref('')
    const alasanTidakAdaNote = ref('')
    const noSkPenghapusan = ref('')

    const bagianDariAsetInduk = ref('')
    const kondisiBarang = ref('')

    const provinsi = ref(null)
    const kabKota = ref(null)
    const kecamatan = ref(null)
    const kelurahan = ref(null)
    const jalan = ref('')
    const noAlamat = ref('')
    const rt = ref('')
    const rw = ref('')
    const kodePos = ref('')

    const latitude = ref('')
    const longitude = ref('')
    const tanda2BatasTanahUtara = ref('')
    const tanda2BatasTanahTimur = ref('')
    const tanda2BatasTanahSelatan = ref('')
    const tanda2BatasTanahBarat = ref('')
    const keteranganBeton = ref('')
    const keteranganBetonSebutkan = ref('')
    const plang = ref('')
    const plangP = ref('')
    const pagar = ref('')
    const pagarP = ref('')
    const catatan = ref('')
    const gambar = ref('')
    const status = ref('')
    const peruntukkan = ref('')
    const isBertingkat = ref('')
    const bertingkatSeharusnya = ref('')
    const kesesuaianKodeBarang = ref('')
    const kibSeharusnya = ref('')
    const kodeBarangSeharusnya = ref('')

    const isShowUbah = ref(true)

    const getKobar = async (kibKobar, kobar = '', kolok = null) => {
      const params = {
        kib: kibKobar,
        cari: kobar,
        kolok,
        length: 100000,
      }

      return await master.getKobar(g, params)
    }

    const getData = async () => {
      const response = await validasiKeberadaan.getBmdDetail(g, {
        id: props.id,
        username: g.$cookies.get('username'),
      })
      const { data, code } = response
      if (code == 200) {
        const {
          KOLOK,
          nama_pd_ukpd_siera,
          kib: kibVal,
          kobar_108,
          nabar_108,
          noreg_108,
          keberadaan: keberadaanVal,
          wujud_bmd,
          bagian_aset_induk,
          alasan_tidak_ada,
          kobar_induk,
          no_register,
          alasan_tidak_ada_note,
          titik_koordinat,
          tbt_utara,
          tbt_timur,
          tbt_selatan,
          tbt_barat,
          dk_ket_beton,
          dk_ket_beton_note,
          pengamanan_papan_plang,
          pengamanan_pagar_batas,
          kondisi,
          di_nm_prop,
          di_nm_rayon,
          di_nm_kec,
          di_nm_kel,
          di_jalan,
          di_no_jalan,
          di_rt,
          di_rw,
          di_kodepos,
          nama_pd_ukpd_pengelola,
          aset_induk,
          alasan_tidak_ada_p,
          pengamanan_papan_plang_p,
          pengamanan_pagar_batas_p,
          nabar_induk,
          validasi_sensus_note,
          status: statusVal,
          nomor_sk_penghapusan,
          id_pd_ukpd_pengelola,
          foto_keberadaan_dok,
          dk_peruntukan_bmd,
          di_m_bertingkat,
          di_m_bertingkat_a,
          di_m_kobar,
          di_m_kobar_kib,
          di_m_kobar_a,
        } = data
        kolok.value = `${KOLOK}::${nama_pd_ukpd_siera}`
        kib.value = kibVal
        kobar.value = kobar_108
        nabar.value = nabar_108
        kodeRegisterBarang.value = noreg_108
        keberadaan.value = keberadaanVal
        wujud.value = wujud_bmd
        alasanTidakAda.value = alasan_tidak_ada
        alasanTidakAdaP.value = alasan_tidak_ada_p
        kobarInduk.value = kobar_induk
        nabarInduk.value = nabar_induk
        registerBarang.value = no_register
        alasanTidakAdaNote.value = alasan_tidak_ada_note
        tanda2BatasTanahUtara.value = tbt_utara
        tanda2BatasTanahTimur.value = tbt_timur
        tanda2BatasTanahSelatan.value = tbt_selatan
        tanda2BatasTanahBarat.value = tbt_barat
        keteranganBeton.value = dk_ket_beton
        keteranganBetonSebutkan.value = dk_ket_beton_note
        plang.value = pengamanan_papan_plang
        pagar.value = pengamanan_pagar_batas
        kondisiBarang.value = kondisi

        provinsi.value = di_nm_prop
        kabKota.value = di_nm_rayon
        kecamatan.value = di_nm_kec
        kelurahan.value = di_nm_kel
        jalan.value = di_jalan
        noAlamat.value = di_no_jalan
        rt.value = di_rt
        rw.value = di_rw
        kodePos.value = di_kodepos

        pdUkpd.value = nama_pd_ukpd_pengelola
        asetInduk.value = aset_induk
        plangP.value = pengamanan_papan_plang_p
        pagarP.value = pengamanan_pagar_batas_p
        catatan.value = validasi_sensus_note
        status.value = statusVal
        noSkPenghapusan.value = nomor_sk_penghapusan
        kolokPdUkpd.value = id_pd_ukpd_pengelola
        peruntukkan.value = dk_peruntukan_bmd
        isBertingkat.value = di_m_bertingkat || ''
        bertingkatSeharusnya.value = di_m_bertingkat_a
        console.log(di_m_kobar)
        kesesuaianKodeBarang.value = di_m_kobar || ''
        kibSeharusnya.value = di_m_kobar_kib || kibVal
        if (di_m_kobar_a) {
          const resKobar = await getKobar(kibSeharusnya.value)
          resKobar.rows.forEach(item => {
            if (item.kode == di_m_kobar_a) {
              kodeBarangSeharusnya.value = `${item.kode} :: ${item.nama}`
            }
          })
        }

        if (titik_koordinat) {
          const titikKoordinat = titik_koordinat.split(',')
          latitude.value = titikKoordinat[0]
          longitude.value = titikKoordinat[1]
        }

        bagianDariAsetInduk.value = bagian_aset_induk
        gambar.value = foto_keberadaan_dok
      }
      isShowUbah.value = false
    }

    getData()

    return {
      kolok,
      kib,
      kobar,
      nabar,
      kodeRegisterBarang,
      keberadaan,
      wujud,
      alasanTidakAda,
      alasanTidakAdaP,
      pdUkpd,
      kobarInduk,
      nabarInduk,
      registerBarang,
      alasanTidakAdaNote,
      bagianDariAsetInduk,
      kondisiBarang,
      provinsi,
      kabKota,
      kecamatan,
      kelurahan,
      jalan,
      noAlamat,
      rt,
      rw,
      kodePos,
      latitude,
      longitude,
      tanda2BatasTanahUtara,
      tanda2BatasTanahTimur,
      tanda2BatasTanahSelatan,
      tanda2BatasTanahBarat,
      keteranganBeton,
      keteranganBetonSebutkan,
      plang,
      pagar,
      asetInduk,
      plangP,
      pagarP,
      catatan,
      status,
      isShowUbah,
      noSkPenghapusan,
      kolokPdUkpd,
      gambar,
      peruntukkan,
      isBertingkat,
      bertingkatSeharusnya,
      kesesuaianKodeBarang,
      kibSeharusnya,
      kodeBarangSeharusnya,
    }
  },
  components: {
    Form,
  },
  props: ['id'],
  data() {
    return {
      action: 'Validasi',
    }
  },
}
</script>
